export enum ClimateActionScopes {
  Scope1,
  Scope2,
  Scope3,
  Aggregated,
}
